import Header from "../components/site/Header";
import VideoBackdrop from "../components/site/VideoBackdrop";
import Hero from "../components/site/Hero";
import CommandCenter from "../components/site/CommandCenter";
import Services from "../components/site/Services";
import About from "../components/site/About";
import Products from "../components/site/Products";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";

export default function HomePage() {
  return (
    <>
      <VideoBackdrop />
      <Header />
      <main className="relative">
        <Hero />
        <div
          id="sections-wrapper"
          style={{
            position: "relative",
            zIndex: 10,
            transform: "translateY(100vh)",
            willChange: "transform",
          }}
        >
          <CommandCenter />
          <Services />
          <About />
          <Products />
          <Contact />
          <Footer />
        </div>
      </main>
    </>
  );
}
